import {$authHost, $host} from "./index";
import {
    FORGOT_PASSWORD,
    LOGIN,
    LOGIN_GOOGLE_CALLBACK,
    LOGIN_GOOGLE_START,
    LOGIN_OAUTH_PROVIDERS,
    LOGIN_YANDEX_CALLBACK,
    LOGIN_YANDEX_START,
    REGISTER,
    USER,
    USER_PASSWORD, USER_SHIPMENT
} from "./ApiEndpoints";
import jwtDecode from "jwt-decode";


export const register = async (username, password, passwordToCompare) => {
    if (password === passwordToCompare) {
        const {data} = await $host.post(REGISTER, {
            'email': username,
            'password': password,
            'passwordToCompare': passwordToCompare
        })
        localStorage.setItem('token', data.token)
        return jwtDecode(data.token)
    }
    else throw new Error("Invalid password")
}

export const login = async (username, password) => {
    const {data} = await $host.post(LOGIN, {username, password})
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const checkToken = async () => {
    try {
        const {data} = await $authHost.get(USER);
        return Boolean(data?.email);
    } catch {
        return false;
    }
};

export const fetchOAuthProviders = async () => {
    const {data} = await $host.get(LOGIN_OAUTH_PROVIDERS)
    return data
}

export const startGoogleLogin = async () => {
    const {data} = await $host.get(LOGIN_GOOGLE_START)
    window.location.href = data
}

export const startYandexLogin = async () => {
    const {data} = await $host.get(LOGIN_YANDEX_START)
    window.location.href = data
}

export const loginGoogle = async (code) => {
    const parameters = {code}
    const {data} = await $host.get(LOGIN_GOOGLE_CALLBACK, {params: parameters})
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const loginYandex = async (code) => {
    const parameters = {code}
    const {data} = await $host.get(LOGIN_YANDEX_CALLBACK, {params: parameters})
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const forgotPassword = async (email) => {
        const response = await $host.post(FORGOT_PASSWORD, {email})
        return response.status
}

export const changePassword = async (oldPassword, newPassword) => {
    const response = await $authHost.post(USER_PASSWORD,
        {
            oldPassword: oldPassword,
            newPassword: newPassword
        })
    return response.status
}

export const fetchShipmentInfo = async () => {
    const response = await $authHost.get(USER_SHIPMENT)
    return response
}

export const updateShipment = async (shipment) => {
    const response = await $authHost.post(USER_SHIPMENT, shipment, {
        headers: {'Content-Type': 'application/json'},
    })
    return response
}


